/**
 * Formats the BIM受領日_フロア display label for a calculation history row.
 * Floors are deduplicated, sorted, and joined.
 * e.g. ("2026-06-15", ["4F"])              → "20260615_4F"
 *      ("2026-06-05", ["2F", "3F"])        → "20260605_2F3F"
 *      ("2026-06-05", ["3F", "2F", "2F"]) → "20260605_2F3F" (deduped and sorted)
 *      ("2026-06-05", [])                  → "20260605"
 */
export function formatCalculationLabel(bimReceivedDate: string, floors: string[]): string {
  const dateStr = bimReceivedDate.replace(/-/g, '');
  if (floors.length === 0) return dateStr;
  const uniqueFloors = Array.from(new Set(floors)).sort();
  return `${dateStr}_${uniqueFloors.join('')}`;
}
